import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { PoshSelectCheckboxListItem } from "../../misc/components/PoshSelectListItem";
import { Link, useNavigate } from "react-router-dom";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import {
    faDiary, faFvc, faSvc, faEcg, faPcf, faDLco, faMip, faMep, faSnip, faPef,
    faBloodPressure, faLungVolume, faCough, faPulseOximetry, faFeNO, faBloodGlucose, faOscillometry, faSixMinutesWalkTest, faMvv, faChallenge,
    faSurvey, faInhaler
} from "@vitalograph/web-ui";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from '@fortawesome/fontawesome-svg-core'; 
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface SessionTypeSelectionProps {
    selectedItem: string;
    onSelect: (id: SessionTypes, multiSelectEnabled: boolean) => void;
    onWizardClose: () => void;
    goTo: (step: string) => void;
}

export const SessionTypeSelection = ({ goTo, selectedItem, onSelect, onWizardClose }: SessionTypeSelectionProps) => {
    const [multipleRecordingsEnabled, setMultipleRecordingsEnabled] = React.useState<boolean>(true);
    const { study, sessionTypes } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getMultipleSelectionEnabled = async () => {
            const multipleRecordingsEnabledResult = await legacyClient.getSetting("cough.sessionConfiguration.multipleRecordingsEnabled", study.id);
            setMultipleRecordingsEnabled(multipleRecordingsEnabledResult);
        }

        getMultipleSelectionEnabled();
    }, [study.id]);

    const onChange = (id: SessionTypes) => {
        onSelect(id, multipleRecordingsEnabled);
        goTo("visit");
    }

    const sessionTypeIcon = (type: SessionTypes) => {
        switch (type) {
            case SessionTypes.Fvc:
                return faFvc;
            case SessionTypes.Svc:
                return faSvc;
            case SessionTypes.Pcf:
                return faPcf;
            case SessionTypes.Ecg:
                return faEcg;
            case SessionTypes.BloodPressure:
                return faBloodPressure;
            case SessionTypes.EDiary:
                return faDiary;
            case SessionTypes.Dlco:
                return faDLco;
            case SessionTypes.Mip:
                return faMip;
            case SessionTypes.Mep:
                return faMep;
            case SessionTypes.Snip:
                return faSnip;
            case SessionTypes.LungVolumeHelium:
                return faLungVolume;
            case SessionTypes.LungVolumePleth:
                return faLungVolume;
            case SessionTypes.Cough:
                return faCough;
            case SessionTypes.PulseOximetry:
                return faPulseOximetry;
            case SessionTypes.Feno:
                return faFeNO;
            case SessionTypes.BloodGlucose:
                return faBloodGlucose;
            case SessionTypes.Oscillometry:
                return faOscillometry;
            case SessionTypes.Pef:
                return faPef;
            case SessionTypes.SixMinuteWalkTest:
                return faSixMinutesWalkTest;
            case SessionTypes.Mvv:
                return faMvv;
            case SessionTypes.Challenge:
                return faChallenge;
            case SessionTypes.SurveyAssistek:
                return faSurvey;
            case SessionTypes.SurveySGRQ:
                return faSurvey;
            case SessionTypes.InhalerTraining:
                return faInhaler;
            default:
                return faCircle;
        }
    }

    return (
        <>
            <div className="modal-body">
                <h2 className="text-primary">Session Type</h2>
                <p className="text-muted">Select a session type to start</p>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="posh-select">
                            {sessionTypes.map(st =>
                                <PoshSelectCheckboxListItem key={`SessionType${st.Id}`} id={st.Id} title={st.Name} icon={sessionTypeIcon(st.Id) as IconProp} isChecked={selectedItem === st.Id} onChange={() => onChange(st.Id)} />
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary btn-outline" onClick={() => onWizardClose()}>Close</button>
            </div>
        </>
    );
}
